import React, { useEffect, useRef, useState } from 'react';
import { Grid } from "@mui/material";
import { useFormContext } from '../Context/Context';
import { useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';

import Loading from "./Loading/Loading";
import CustomToast from './CustomToast/CustomToast';
import { useLoading } from '../Context/LoadingContext';
import ImageUploader from './ImageComponent/ImageUploader';

import {
  isEditablePage,
  uploadImageToServer,
  syncImageIdWithDrawer
} from './ImageComponent/imageHelpers';

const Image = ({ id }) => {

  const { drawerData } = useFormContext();
  const { loading, setLoading } = useLoading();

  const location = useLocation();
  const currentPage = location.pathname;
  const existingComponentIndex = drawerData.findIndex(component => component.id === id);

  const [image, setImage] = useState(null);
  const [imageId, setImageId] = useState(drawerData[existingComponentIndex]?.state.mainImage);
  const [isHeadingFocused, setHeadingFocused] = useState(false);
  const containerRefs = useRef(null);

  const token = localStorage.getItem('authToken');
  const FormId = localStorage.getItem('createFormId');

  const isReadOnly = !isEditablePage(currentPage);

  const handleImageChange = (e) => {
    if (isEditablePage(currentPage)) {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => setImage(reader.result);
        reader.readAsDataURL(file);
      }
    }
  };

  const handleClickOutside = (event) => {
    if (containerRefs.current && !containerRefs.current.contains(event.target)) {
      setHeadingFocused(false);
    } else {
      setHeadingFocused(true);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  useEffect(() => {
    syncImageIdWithDrawer(drawerData, existingComponentIndex, imageId);
  }, [id, imageId]);

  useEffect(() => {
    if (image) {
      uploadImageToServer({
        image,
        token,
        FormId,
        setImage,
        setImageId,
        setLoading,
        toast,
        CustomToast,
      });
    }
  }, [image]);

  return (
    <>
      {
      loading ? (
        <Loading />
      ) : (
        <Grid
          border={`2px solid ${isHeadingFocused && !isReadOnly ? '#0293e2' : 'transparent'}`}
          onClick={handleClickOutside}
          mb={['/build', '/Publish'].includes(currentPage) ? '28px' : '50px'}
          p={['/build', '/Publish'].includes(currentPage) ? '12px 10px' : '24px 36px'}
          borderRadius={'3px'}
          mx={['/build', '/Publish'].includes(currentPage) ? '4px' : '0px'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          ref={containerRefs}
        >
          <ImageUploader
            image={image || drawerData[existingComponentIndex]?.state.mainImage}
            onChange={handleImageChange}
            isReadOnly={isReadOnly}
          />
        </Grid>
      )}
    </>
  );
};

export default Image;
